<div class="form-control">
    <label for="stripeCard">{{ 'SHOP.SHARED.STRIPE.TITLE_FORM' | translate }}</label>
    <ngx-stripe-card
        [id]="'stripeCard'"
        aria-labelledby="stripe-label"
        [options]="cardOptions"
        [elementsOptions]="elementsOptions"
        (change)="onCcInputsChange($event)"
        [stripe]="stripe"
    >
    </ngx-stripe-card>
    <p class="error" *ngIf="ccErrorMessage">{{ ccErrorMessage }}</p>
    <p class="error" *ngIf="showGenericError">{{ 'SHARED.GENERIC_ERROR' | translate }}</p>
</div>

<app-generic-button
    [classes]="'btn btn--primary'"
    [disabled]="buttonDisabled || amountControl.invalid"
    [inputText]="'SHOP.SHARED.STRIPE.BUTTON_FORM'"
    (buttonClick)="pay()"
></app-generic-button>
